export default __webpack_public_path__ + "static/about-11ed0e8bd337dde6b03c2abc7e93a01a.mp4";